/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { GetAusschreibungByAusschreibungNummerResponse as AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse } from '../models/ace/xFound/Portal/Core/CAQ/Ausschreibung/Queries/get-ausschreibung-by-ausschreibung-nummer-response';
import { DocumentDisplayModel as AceXFoundPortalCoreCaqModelsDocumentDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { AusschreibungsNummer as AceXFoundPortalCoreModelsAusschreibungsNummer } from '../models/ace/xFound/Portal/Core/Models/ausschreibungs-nummer';

@Injectable({
providedIn: 'root',
})

export class AusschreibungService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiAusschreibungAusschreibungNummerGet
   */
  static readonly ApiAusschreibungAusschreibungNummerGetPath = '/api/Ausschreibung/{AusschreibungNummer}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAusschreibungAusschreibungNummerGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerGet$Plain$Response(params: {
    AusschreibungNummer: AceXFoundPortalCoreModelsAusschreibungsNummer;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AusschreibungService.ApiAusschreibungAusschreibungNummerGetPath, 'get');
    if (params) {
      rb.path('AusschreibungNummer', params.AusschreibungNummer, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAusschreibungAusschreibungNummerGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerGet$Plain(params: {
    AusschreibungNummer: AceXFoundPortalCoreModelsAusschreibungsNummer;
  }): Observable<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse> {

    return this.apiAusschreibungAusschreibungNummerGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse>) => r.body as AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAusschreibungAusschreibungNummerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerGet$Response(params: {
    AusschreibungNummer: AceXFoundPortalCoreModelsAusschreibungsNummer;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AusschreibungService.ApiAusschreibungAusschreibungNummerGetPath, 'get');
    if (params) {
      rb.path('AusschreibungNummer', params.AusschreibungNummer, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAusschreibungAusschreibungNummerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerGet(params: {
    AusschreibungNummer: AceXFoundPortalCoreModelsAusschreibungsNummer;
  }): Observable<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse> {

    return this.apiAusschreibungAusschreibungNummerGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse>) => r.body as AceXFoundPortalCoreCaqAusschreibungQueriesGetAusschreibungByAusschreibungNummerResponse)
    );
  }

  /**
   * Path part for operation apiAusschreibungAusschreibungNummerAllUnterlagenGet
   */
  static readonly ApiAusschreibungAusschreibungNummerAllUnterlagenGetPath = '/api/Ausschreibung/{AusschreibungNummer}/AllUnterlagen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAusschreibungAusschreibungNummerAllUnterlagenGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerAllUnterlagenGet$Plain$Response(params: {
    AusschreibungNummer: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AusschreibungService.ApiAusschreibungAusschreibungNummerAllUnterlagenGetPath, 'get');
    if (params) {
      rb.path('AusschreibungNummer', params.AusschreibungNummer, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAusschreibungAusschreibungNummerAllUnterlagenGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerAllUnterlagenGet$Plain(params: {
    AusschreibungNummer: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    return this.apiAusschreibungAusschreibungNummerAllUnterlagenGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAusschreibungAusschreibungNummerAllUnterlagenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerAllUnterlagenGet$Response(params: {
    AusschreibungNummer: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AusschreibungService.ApiAusschreibungAusschreibungNummerAllUnterlagenGetPath, 'get');
    if (params) {
      rb.path('AusschreibungNummer', params.AusschreibungNummer, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAusschreibungAusschreibungNummerAllUnterlagenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerAllUnterlagenGet(params: {
    AusschreibungNummer: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    return this.apiAusschreibungAusschreibungNummerAllUnterlagenGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>)
    );
  }

  /**
   * Path part for operation apiAusschreibungAusschreibungNummerUnterlagenGet
   */
  static readonly ApiAusschreibungAusschreibungNummerUnterlagenGetPath = '/api/Ausschreibung/{AusschreibungNummer}/Unterlagen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAusschreibungAusschreibungNummerUnterlagenGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerUnterlagenGet$Plain$Response(params: {
    AusschreibungNummer: string;
    documentIds?: Array<string>;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AusschreibungService.ApiAusschreibungAusschreibungNummerUnterlagenGetPath, 'get');
    if (params) {
      rb.path('AusschreibungNummer', params.AusschreibungNummer, {});
      rb.query('documentIds', params.documentIds, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAusschreibungAusschreibungNummerUnterlagenGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerUnterlagenGet$Plain(params: {
    AusschreibungNummer: string;
    documentIds?: Array<string>;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    return this.apiAusschreibungAusschreibungNummerUnterlagenGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAusschreibungAusschreibungNummerUnterlagenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerUnterlagenGet$Response(params: {
    AusschreibungNummer: string;
    documentIds?: Array<string>;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AusschreibungService.ApiAusschreibungAusschreibungNummerUnterlagenGetPath, 'get');
    if (params) {
      rb.path('AusschreibungNummer', params.AusschreibungNummer, {});
      rb.query('documentIds', params.documentIds, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAusschreibungAusschreibungNummerUnterlagenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAusschreibungAusschreibungNummerUnterlagenGet(params: {
    AusschreibungNummer: string;
    documentIds?: Array<string>;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    return this.apiAusschreibungAusschreibungNummerUnterlagenGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>)
    );
  }

}